<template>
    <div class="admin_main_wrapper">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <b-dropdown :text="lang.current">
            <b-dropdown-item v-for="(item, index) in lang.items" :key="index"
                             v-on:click="changeCurrentLanguage(item)">
                <span>{{item}}</span>
            </b-dropdown-item>
        </b-dropdown>
        <div style="display: flex;">
            <div class="main_wrapper tags">
                <div class="raw_wrapper" style="margin-left: 10px;">
                    <md-field class="tag_name">
                        <label>New tag name</label>
                        <md-input v-model="tags.newTag.text"/>
                    </md-field>
                    <md-field class="sort_order">
                        <label>Order</label>
                        <md-input v-model="tags.newTag.sort_order"/>
                    </md-field>
                    <div class="buttons" style="margin-right: 10px;">
                        <img src="@/assets/icons/ic_content-save.svg" class="action_btn"
                             :class="{active:true}"
                             @click="createNewTag()"/>
                    </div>
                </div>
                <div style="background-color: black; height: 1px; margin-top: 8px;"></div>
                <ul>
                    <li v-for="(tag, tag_index) in tags.items" :key="tag_index">
                        <!--                    <span class="name">{{tag.text}}</span>-->
                        <div class="raw_wrapper editable" @click="onTagClick(tag.uid)">
                            <md-field class="tag_name">
                                <label>Name</label>
                                <md-input v-model="tags.items[tag_index].newData.text"
                                          :disabled="tags.selectedUid !== tag.uid"></md-input>
                            </md-field>
                            <md-field class="sort_order">
                                <label>Order</label>
                                <md-input v-model="tags.items[tag_index].newData.sort_order"
                                          :disabled="tags.selectedUid !== tag.uid"></md-input>
                            </md-field>
                            <div class="buttons"
                                 :style="tags.selectedUid == tag.uid ? 'visibility: visible;' : 'visibility: hidden;'">
                                <img src="@/assets/icons/ic_content-save.svg" class="action_btn"
                                     :class="{active:isTagChanged(tag)}"
                                     @click="saveTag(tag)"/>
                                <img src="@/assets/icons/ic_refresh.svg" class="action_btn"
                                     :class="{active:isTagChanged(tag)}"
                                     @click="resetTag(tag)"/>
                                <img src="@/assets/icons/ic_delete.svg" class="action_btn active"
                                     @click="onDeleteTagClick(tag)"/>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="main_wrapper questions">
                <div class="raw_wrapper" style="margin-left: 10px;">
                    <div style="display: flex; flex: none; flex-direction: column; align-items: flex-end; margin-right: 5px;"
                         :style="tags.selectedUid ? 'visibility: visible;' : 'visibility: hidden;'">
                        <label style="font-size: 12px;">link tag</label>
                        <b-form-checkbox
                                v-model="questions.new.linkWithCurrentTag" style="width: 20px; height: 20px;"/>
                    </div>
                    <md-field class="tag_name">
                        <label>New question name</label>
                        <md-input v-model="questions.new.text"/>
                    </md-field>
                    <div class="buttons" style="margin-right: 10px;">
                        <img src="@/assets/icons/ic_content-save.svg" class="action_btn"
                             :class="{active:true}"
                             @click="createNewQuestion()"/>
                    </div>
                </div>
                <div style="background-color: black; height: 1px; margin-top: 8px;"></div>
                <ul>
                    <li v-for="(question, question_index) in questions.items" :key="question_index">
                        <div class="raw_wrapper editable" @click="onQuestionClick(question)">
                            <div style="display: flex; flex: none; align-items: flex-end; margin-right: 5px;">
                                <b-form-checkbox
                                        v-model="question.linkedWithCurrentTag" style="width: 20px; height: 20px;"
                                        :style="tags.selectedUid ? 'visibility: visible;' : 'visibility: hidden;'"
                                        @change="onQuestionTemplateCheckChanged(question)"/>
                            </div>
                            <md-field class="tag_name">
                                <label>{{question.tagsMerged || ''}}</label>
                                <md-input v-model="questions.items[question_index].newData.text"
                                          :disabled="questions.selectedUid !== question.uid"></md-input>
                            </md-field>
                            <div class="buttons"
                                 :style="questions.selectedUid == question.uid ? 'visibility: visible;' : 'visibility: hidden;'">
                                <img src="@/assets/icons/ic_content-save.svg" class="action_btn"
                                     :class="{active:isQuestionChanged(question)}"
                                     @click="saveQuestion(question)"/>
                                <img src="@/assets/icons/ic_refresh.svg" class="action_btn"
                                     :class="{active:isQuestionChanged(question)}"
                                     @click="resetQuestion(question)"/>
                                <img src="@/assets/icons/ic_delete.svg" class="action_btn active"
                                     @click="onDeleteQuestionClick(question)"/>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>

        </div>

    </div>
</template>

<script>
    import {mapActions, mapMutations, mapState} from "vuex";
    import InfiniteLoading from "vue-infinite-loading";
    import customModalDialog from '@/components/widgets/customModalDialog';
    import errorMixin from '@/mixins/errorMixin';
    import adminPageMixin from "@/mixins/adminPageMixin";


    export default {
        name: 'landingQuestions',
        mixins: [errorMixin, adminPageMixin,],
        components: {
            InfiniteLoading,
            customModalDialog
        },

        data() {
            return {
                customModalSettings: {},
                lang: {
                    current: 'en',
                    items: this.$ml.list
                },
                questions: {
                    raw: [],
                    selectedUid: null,
                    new: {
                        text: "",
                        linkWithCurrentTag: true,
                    },
                    items: [],
                },
                tags: {
                    selectedUid: null,
                    newTag: {
                        text: "",
                        sort_order: 100,
                    },
                    items: [],
                },
            }
        },

        props: ['infinity'],

        watch: {
            infinity(val) {
                this.setAccounts([])
                this.page = 1
            }
        },

        computed: {
            ...mapState({
                accounts: state => state.closeAccount.accounts
            })
        },
        mounted() {
            this.initAdminPage()
            this.refreshAll()
        },
        methods: {

            ...mapActions({
                getQuestionTags: 'startQuestions/getQuestionTags',
                editQuestionTag: 'startQuestions/editQuestionTag',
                createQuestionTag: 'startQuestions/createQuestionTag',
                deleteQuestionTag: 'startQuestions/deleteQuestionTag',
                getQuestionTemplates: 'startQuestions/getQuestionTemplates',
                editQuestionTemplate: 'startQuestions/editQuestionTemplate',
                createQuestionTemplate: 'startQuestions/createQuestionTemplate',
                deleteQuestionTemplate: 'startQuestions/deleteQuestionTemplate',
                attachQuestionTemplate: 'startQuestions/attachQuestionTemplate',
                detachQuestionTemplate: 'startQuestions/detachQuestionTemplate',
            }),

            ...mapMutations({
                setMessageModel: 'setMessageModel'
            }),

            async refreshAll() {
                await this.fetchData()
                await this.fetchQuestions()
                await this.prepareQuestions()
                this.questions.selectedUid = null
                this.questions.new.text = ''
            },

            async fetchData() {
                try {
                    const response = await this.getQuestionTags({
                        lang: this.lang.current
                    });
                    var tags = response.collection
                    for (let i = 0; tags.length > i; i++) {
                        tags[i].newData = JSON.parse(JSON.stringify(tags[i]))
                    }
                    this.tags.items = tags

                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                }
            },

            refreshTagsMerged(q) {
                var tagsMerged = ''
                for (let t = 0; q.tags.length > t; t++) {
                    if (tagsMerged != '') {
                        tagsMerged += ', '
                    }
                    tagsMerged += `${q.tags[t].text}`
                }
                q.tagsMerged = tagsMerged
            },

            async fetchQuestions() {
                try {
                    const response = await this.getQuestionTemplates({
                        // lang: this.lang.current
                    });
                    var questions = response.collection
                    for (let i = 0; questions.length > i; i++) {
                        var q = questions[i]
                        q.newData = JSON.parse(JSON.stringify(q))
                        this.refreshTagsMerged(q)
                    }
                    this.questions.raw = questions
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                }
            },

            isTagChanged(item) {
                if (item.sort_order == '') {
                    return true
                }
                return item.text !== item.newData.text || parseInt(item.sort_order) !== parseInt(item.newData.sort_order)
            },

            isQuestionChanged(item) {
                return item.text !== item.newData.text
            },

            async onTagClick(tagUid) {
                this.tags.selectedUid = tagUid
                this.prepareQuestions()
            },

            prepareQuestions() {
                var items = []
                for (var i = 0; this.questions.raw.length > i; i++) {
                    let q = this.questions.raw[i]
                    q.linkedWithCurrentTag = false
                    if (q.tags && q.tags.length > 0) {
                        if (q.tags.find(item => item.lang == this.lang.current)) {
                            if (q.tags.find(item => item.uid == this.tags.selectedUid)) {
                                q.linkedWithCurrentTag = true
                            }
                            items.push(q)
                        }
                    } else {
                        items.push(q)
                    }
                }
                items.sort(function(q1, q2) {
                    if(q1.linkedWithCurrentTag && !q2.linkedWithCurrentTag) {
                        return -1
                    }
                    return 0;
                });
                this.questions.items = items
            },

            async createNewTag() {
                try {
                    let sortOrder = parseInt(this.tags.newTag.sort_order)
                    const response = await this.createQuestionTag({
                        lang: this.lang.current,
                        text: this.tags.newTag.text,
                        sort_order: sortOrder
                    });
                    this.tags.newTag.text = ''
                    this.setMessageModel({
                        msg: 'New tag added',
                        duration: 1000
                    })
                    await this.refreshAll()
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                }
            },
            async saveTag(item) {
                try {
                    let sortOrder = parseInt(item.newData.sort_order)
                    const response = await this.editQuestionTag({
                        uid: item.uid,
                        text: item.newData.text,
                        lang: item.lang,
                        sort_order: sortOrder
                    });
                    item.text = item.newData.text
                    item.sort_order = item.newData.sort_order
                    this.setMessageModel({
                        msg: 'Tag saved',
                        duration: 1000
                    })
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                }
            },
            async resetTag(item) {
                item.newData = null
                item.newData = JSON.parse(JSON.stringify(item))
            },

            onDeleteTagClick(item) {
                this.customModalSettings = {
                    message: `Are you sure to delete this tag? ${item.text}`,
                    onOkHandler: this.deleteTag.bind(null, item),
                    showCancelButton: true,
                    okButtonText: `Delete`,
                    cancelButtonText: `Cancel`
                }
            },
            async deleteTag(item) {
                try {
                    const response = await this.deleteQuestionTag({
                        uid: item.uid
                    });
                    this.tags.selectedUid = null
                    var index = this.tags.items.indexOf(item);
                    if (index !== -1) {
                        this.tags.items.splice(index, 1);
                    }
                    this.setMessageModel({
                        msg: 'Tag deleted',
                        duration: 1000
                    })
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                }
            },

            onQuestionClick(question) {
                this.questions.selectedUid = question.uid
            },

            async onQuestionTemplateCheckChanged(question) {
                let newValueLinked = !question.linkedWithCurrentTag
                console.log(`onQuestionTemplateCheckChanged checked new value:${newValueLinked}`)
                try {
                    let item = {
                        question_uid: question.uid,
                        tag_uid: this.tags.selectedUid
                    }
                    let response
                    let msg
                    if (newValueLinked) {
                        response = await this.attachQuestionTemplate(item);
                        msg = 'Tag linked'
                    } else {
                        response = await this.detachQuestionTemplate(item);
                        msg = 'Tag unlinked'
                    }
                    question.tags = response.template.tags
                    this.refreshTagsMerged(question)
                    this.setMessageModel({
                        msg: msg,
                        duration: 1000
                    })
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                }
            },

            async createNewQuestion() {
                try {
                    var response = await this.createQuestionTemplate({
                        text: this.questions.new.text,
                    });
                    console.log(response)
                    var template = response.template
                    console.log(template)
                    this.questions.new.text = ''
                    var msg = 'New question template added'
                    if(this.questions.new.linkWithCurrentTag && this.tags.selectedUid) {
                        let item = {
                            question_uid: template.uid,
                            tag_uid: this.tags.selectedUid
                        }
                        const response = await this.attachQuestionTemplate(item);
                        msg = `New question template added. Linked with tag`
                    }
                    this.setMessageModel({
                        msg: msg,
                        duration: 1000
                    })
                    await this.fetchQuestions()
                    await this.prepareQuestions()
                } catch (e) {
                    console.log(e)
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                }
            },

            async saveQuestion(item) {
                try {
                    const response = await this.editQuestionTemplate({
                        uid: item.uid,
                        text: item.newData.text,
                    });
                    item.text = item.newData.text
                    this.setMessageModel({
                        msg: 'Question template saved',
                        duration: 1000
                    })
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                }
            },
            async resetQuestion(item) {
                item.newData = null
                item.newData = JSON.parse(JSON.stringify(item))
            },

            onDeleteQuestionClick(item) {
                this.customModalSettings = {
                    message: `Are you sure to delete this question template? ${item.text}`,
                    onOkHandler: this.deleteQuestion.bind(null, item),
                    showCancelButton: true,
                    okButtonText: `Delete`,
                    cancelButtonText: `Cancel`
                }
            },
            async deleteQuestion(item) {
                try {
                    const response = await this.deleteQuestionTemplate({
                        uid: item.uid
                    });
                    this.questions.selectedUid = null
                    var index = this.questions.items.indexOf(item);
                    if (index !== -1) {
                        this.questions.items.splice(index, 1);
                    }
                    this.setMessageModel({
                        msg: 'Question template deleted',
                        duration: 1000
                    })
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                }
            },

            changeCurrentLanguage(item) {
                this.lang.current = item
                this.refreshAll()
            },

        }

    }
</script>

<style scoped>

    .main_wrapper {
        border: 1px solid black;
        width: 450px;
        height: 500px;
        overflow: scroll;
    }

    .main_wrapper .md-field {
        height: 40px;
    }

    .main_wrapper ul {
        display: flex;
        flex-direction: column;
    }

    .tag_wrapper_full {
        /*width: 300px;*/
        /*border: 1px solid rgba(47, 47, 47, 0.51);*/
    }

    .raw_wrapper {
        display: flex;
        height: 50px;
    }

    .tag_name {
        /*width: 140px;*/
    }

    .tag_name .md-input {
        /*width: 140px;*/
    }

    .sort_order {
        margin-left: 10px;
        width: 50px;
    }

    .sort_order .md-input {
        width: 50px;
    }

    .raw_wrapper .buttons {
        display: flex;
        flex: none;
        align-items: flex-end;
    }

    .raw_wrapper .buttons img {
        width: 25px;
        height: 25px;
        cursor: pointer;
        opacity: 0.3;
    }

    .raw_wrapper .buttons img:active {
        border: 2px solid transparent;
    }

    .raw_wrapper .buttons img.active {
        opacity: 1;
    }
</style>
